<div *ngIf="userdefinedDataLoaded && userDefinedColsLoaded">
<div class="heading-row-line"> <a (click)="navigateToUserdefinedData()" class="view-more-link">
            Click Here
        </a> to view User Defined Data</div>
        <div class="heading-row">
        Details of custom columns added</div>
    <div class="panel-card">

        <!-- Table Header -->
        <table class="table table-hover align-middle">
            <thead>
                <tr>
                    <th class="sl-no"></th>
                    <th><strong>Column Name</strong></th>
                    <th><strong>ISO Program</strong></th>
                    <th><strong>ISO Matching Column</strong></th>
                </tr>
            </thead>


            <tbody>
                <tr *ngFor="let item of userdefiledcols;let row=index">
                    <td class="sl-no">{{ row + 1 }}</td>
                    <td>{{ item.ColName }}</td>
                    <td>
                        <div *ngIf="item.ISOCol=='on';else default">
                            Yes
                        </div>
                        <ng-template #default>
                            <div>No</div>
                        </ng-template>
                    </td>
                    <td>{{ item.MatchCol }}</td>
                </tr>
            </tbody>
        </table>

    </div>
     <hr class="section-separator">
    <div class="heading-row">
        Premium Details</div>
    <div class="panel-card">

        <!-- Table Header -->
        <table class="table table-hover align-middle">
            <thead>
                <tr>
                    <th><strong>Premium</strong></th>
                    <th><strong>Value</strong></th>
                </tr>
            </thead>

            <tbody>
                <tr>
                    <td class="label">{{ 'premium.userDefinedDirect' | label }}</td>
                    <td class="value">{{ userdefined_direct_total| number:'1.0-0' }}</td>
                </tr>
                <tr>
                    <td class="label">{{ 'premium.userDefinedSupplemental' | label }}</td>
                    <td class="value">{{ userdefined_supplemental_total | number:'1.0-0' }}</td>
                </tr>
                <tr>
                    <td class="label total-row">Total Premium</td>
                    <td class="value total-row">{{ (userdefined_direct_total + userdefined_supplemental_total) |
                        number:'1.0-0' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
   
    
    
</div>